module.exports = __webpack_public_path__ + "img/UTOTTE-5.cbcaabaa.jpg";